<template>
  <v-dialog
    v-model="dialog"
    :width="step == 0? '420px': '330px'">
    <div
      class="dialog-container"
      :style="{padding:step==0?'':'15px'}">
      <template v-if="step == 0">
        <div class="plan-header">
          <div class="info flex">
            <h3>Mark As Issued</h3>

            <i
              class="el-icon-close"
              @click="dialog=false"></i>
          </div>
        </div>
        <div class="dialog-body">
          <!--        <h3>Add Official Policy</h3>-->
          <p>This policy will advance to "Issued."</p>

          <el-form
            ref="form"
            :rules="rules"
            :model="formData">
            <div class="item-content">
              <div class="form-item">
                <span>Official Policy</span>
                <el-form-item
                  ref="pcy_pdf_path_id"
                  prop="pcy_pdf_path_id">
                  <v-upload
                    :card="true"
                    :fileData="formData.pcy_pdf"
                    :edit="true"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </el-form-item>
              </div>
              <div
                v-if="!isHzmb"
                class="form-item">
                <span>Policy No.</span>
                <el-form-item
                  ref="pcy_no"
                  prop="pcy_no">
                  <v-input v-model="formData.pcy_no" />
                </el-form-item>
              </div>
              <template v-if="isHzmb">
                <div
                  class="form-item">
                  <span>交强險</span>
                  <el-form-item
                    ref="pcy_no_1"
                    :rules="rules.input"
                    prop="pcy_no_1">
                    <v-input v-model="formData.pcy_no_1" />
                  </el-form-item>
                </div>
                <div
                  class="form-item">
                  <span>優粵行</span>
                  <el-form-item
                    ref="pcy_no_2"
                    :rules="rules.input"
                    prop="pcy_no_2">
                    <v-input v-model="formData.pcy_no_2" />
                  </el-form-item>
                </div>
                <div
                  class="form-item">
                  <span>商業險</span>
                  <el-form-item
                    ref="pcy_no_3"
                    :rules="rules.input"
                    prop="pcy_no_3">
                    <v-input v-model="formData.pcy_no_3" />
                  </el-form-item>
                </div>
              </template>
              <div class="form-item">
                <span>Insured Period</span>
                <div class="flex flex-align">
                  <el-form-item
                    ref="ins_start_dt"
                    prop="ins_start_dt">
                    <v-date-picker
                      v-model="formData.ins_start_dt"
                    />
                  </el-form-item>
                  <span class="margin-time">To</span>
                  <el-form-item
                    ref="ins_end_dt"
                    prop="ins_end_dt">
                    <v-date-picker
                      v-model="formData.ins_end_dt"
                    />
                  </el-form-item>
                </div>
              </div>
            </div>
            <template v-if="extraBenefit.length>0">
              <div class="title-span">Extra Benefit </div>
              <div
                v-for="(item,index) in extraBenefit"
                :key="'extra'+index"
                class="item-content">
                <div class="form-item">
                  <span>{{item.name}}</span>
                  <el-form-item
                    :ref="`${item.key}_path_id`"
                    :rules="rules.extra_upload"
                    :prop="`${item.key}_path_id`">
                    <v-upload
                      :card="true"
                      :fileData="item[`${item.key}_path`]"
                      :otherData="{
                        target: 'extra_benefits',
                        idKey: `${item.key}_path_id`,
                        nameKey:`${item.key}_path`,
                        index
                      }"
                      :edit="true"
                      @delete="handlerDeleteFile"
                      @uploadSuccess="handlerUploadSuccess"
                    />
                  </el-form-item>
                </div>
                <div
                  class="form-item">
                  <span>{{item.name}} Policy No.</span>
                  <el-form-item
                    :ref="`${item.key}_pcy_no`"
                    :rules="rules.extra_input"
                    :prop="`${item.key}_pcy_no`">
                    <v-input v-model="formData[`${item.key}_pcy_no`]" />
                  </el-form-item>
                </div>
              </div>
            </template>
          </el-form>
        </div>
        <div class="dialog-footer">
          <v-button @click="dialog = false">Cancel</v-button>
          <v-button
            type="primary"
            @click="onContinue">Continue</v-button>
        </div>
      </template>
      <template v-else>
        <send-email-sms
          ref="send-email-sms"
          :initContent="form.enter_policy_url_data"
          :init-referrer-content="form.referrer_enter_policy_url_data"
          :emailListTitle="emailListTitle"
          :emailTitle="emailTitle"
          :form="sendForm"
          is-issued
          :is-fina="isFina"
          show-referrer
          :orderId="orderId"
          @cancel="dialog = false"
          @send="onSend"
          @skip="onSkip" />
      </template>
    </div>

  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import {orderEnterPcyNo, sendOrderEnterPcyNoNotice} from '@/api/order'
import SendEmailSms from './send-email-sms'
import dayjs from 'dayjs'

export default {
  name: 'MarkAsIssuedDialog',
  components: {
    SendEmailSms,
  },
  mixins: [MixinRules,MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    changeUploadData: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    const checkUpload = (rule, value, cb) => {
      let {field} = rule
      if(!this.formData[field]){
        cb(new Error(this.$t('placeholder.upload')))
      }
      cb()
    }
    const checkInput = (rule, value, cb) => {
      let {field} = rule
      if(!this.formData[field]){
        cb(new Error(this.$t('placeholder.input')))
      }
      cb()
    }
    return {
      dialog: false,
      step: 0,
      extraBenefit:[],
      formData: {
        pcy_no: '',
        pcy_no_1: '',
        pcy_no_2: '',
        pcy_no_3: '',
        pcy_pdf: null,
        pcy_pdf_path: '',
        pcy_pdf_path_id: '',
        ins_start_dt: '',
        ins_end_dt: '',
        date: []
      },
      sendFormData: {
        content: ''
      },
      extraRules: {
        pcy_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        date: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        pcy_pdf_path_id: [
          { required: true, message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] }
        ],
        extra_upload: [
          {validator: checkUpload, trigger: ['change', 'blur'] }
        ],
        extra_input: [
          {validator: checkInput, trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed:{
    emailListTitle(){
      return this.form.enter_policy_url_list_title || ''
    },
    emailTitle(){
      return this.form.enter_policy_url_title || ''
    },
    isFina(){
      let {merchant_platform,is_guest_order} = this.form||{}
      return merchant_platform == 2||is_guest_order==1
    },
    sendForm(){
      let {product_id,customer,referrer} = this.form||{}
      if(product_id>=80)
        return  {...this.form,identity:2}
      return product_id>=80? {...this.form,...customer}:this.form
    },
    isNewSME(){
      let {sme_versions} = this.form||{}
      return sme_versions==3
    },
    isSME(){
      let {product_id,customer} = this.form||{}
      return product_id>=80
    },
    isHzmb(){
      let {class_id} = this.form||{}
      return class_id ==15
    }
  },
  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        if(val) {
          this.initExtra()
          const { pcy_no_1,pcy_no_2,pcy_no_3,cy_no,ins_start_dt,ins_end_dt, extra_benefits_content,extra_content_list,pcy_cmnt_dt, pcy_expry_dt} = this.form
          const { file } = this.changeUploadData
          const {path,id} = file||{}
          // Object.keys(extra_benefits_content).some((item)=>{
          //   this.formData[item] = {}
          // })
          this.formData.pcy_pdf = file
          this.formData.pcy_pdf_path_id = id
          this.formData.pcy_pdf_path = path
          if(this.form.product_id == 14){
            this.formData.ins_start_dt = pcy_cmnt_dt
            this.formData.ins_end_dt = pcy_expry_dt
          }else if(!this.isSME&&this.form.product_id != 14){
            this.formData.ins_start_dt = ins_start_dt
            this.formData.ins_end_dt = ins_end_dt
          }
          if(pcy_no) {
            this.formData.pcy_no = pcy_no
          }
          if(this.isHzmb){
            this.formData.pcy_no_1 = pcy_no_1
            this.formData.pcy_no_2 = pcy_no_2
            this.formData.pcy_no_3 = pcy_no_3
          }
        }
      }
    },
    'formData.ins_start_dt':{
      immediate:true,
      handler(val){
        let {pcy_period} = this.form
        console.log(pcy_period)
        if(pcy_period>0&&val&&!this.isSME)
          this.formData.ins_end_dt = dayjs(val).add(pcy_period,'month').subtract(1,'day').format('YYYY-MM-DD')
      }
    },
  },
  methods: {
    initExtra(){
      let {extra_content_list={},extra_benefits_content} = this.form
      let extraArr =[]
      if(!extra_content_list || extra_content_list.length == 0)
        extra_content_list = {...extra_benefits_content}
      Object.entries(extra_content_list).filter(item=>{
        let params ={}
        let {file={},name='',pcy_no=''} = item[1]
        let {id} =file||{}
        params[`${item[0]}_path`] = file
        params[`${item[0]}_path_id`] = id
        params.key = item[0]
        params.name = name
        params[`${item[0]}_pcy_no`] = pcy_no
        this.formData[`${item[0]}_path_id`] =id||''
        this.formData[`${item[0]}_pcy_no`] =pcy_no||''
        extraArr.push(params)
      })
      this.extraBenefit = extraArr
    },
    changeDialog() {
      this.step = 0
      this.dialog = !this.dialog
    },
    handlerUploadSuccess({ data, result,otherData }) {
      const {type, idKey, nameKey, index = '', urlKey, target} = otherData
      const {id = '', name = '', url = '', client_name = ''} = data
      if (target == 'extra_benefits') {
        this.$set(this.extraBenefit[index], nameKey, data)
        this.$set(this.extraBenefit[index], idKey, id)
        this.formData[idKey] = id
        this.$refs['form'].clearValidate([idKey])
      }else{
        this.$set(this.formData, 'pcy_pdf', data)
        this.$set(this.formData, 'pcy_pdf_path_id', data.id)
        this.$set(this.formData, 'pcy_pdf_path', data.path)
        this.$refs['form'].clearValidate(['pcy_pdf_path_id'])
      }
    },
    handlerDeleteFile({otherData}) {
      const {type, idKey, nameKey, index = '', urlKey, target} = otherData
      if (target == 'extra_benefits') {
        this.$set(this.extraBenefit[index], nameKey, {})
        this.$set(this.extraBenefit[index], idKey, '')
        this.formData[idKey] = ''
      }
      else{
        this.$set(this.formData, 'pcy_pdf', null)
        this.$set(this.formData, 'pcy_pdf_path_id', '')
        this.$set(this.formData, 'pcy_pdf_path', '')
        this.$refs['form'].clearValidate(['pcy_pdf_path_id'])
      }
    },
    onContinue() {
      let {ins_start_dt,ins_end_dt,pcy_no_1} = this.formData||{}
      let {period} = this.form||{}
      let range1 = {
        start: '',
        end: ''
      }
      if(period)
      {
        const [startDate, endDate] = period.split(' - ')
        range1 = {
          start: startDate,
          end: endDate
        }
      }
      const range2 = {
        start: ins_start_dt,
        end: ins_end_dt
      }
      if(this.isHzmb)
        this.formData.pcy_no = pcy_no_1
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          if(this.isSameRange(range1,range2)){
            this.step = 1
          }else 
            this.$ConfirmBox({
              isNewConfirm:true,
              width:500,
              title:'Tips',
              confirmBtn:'Confirm',
              isGreen:true,
              cancelBtn:'Not Correct',
              message: `The Insured Period you filled in does not match the Expected Insured Period.<br/>Please confirm the period <span class="fs-14 fw-600 color-danger">${this.showHKDate(ins_start_dt)} - ${this.showHKDate(ins_end_dt)}</span> is correct ?`
            }).then( () => {
              this.step = 1
            })
        }
        else {
          console.log(rules)
        }
      })
    },
    onSend(data) {
      //   this.$refs['send-form'].validate((valid, rules) => {
      //     if(valid) {
      let {content,referrer_send,referrer_content,customer_send} =data
      let params = {
        content,
        referrer_content,
      }
      if(!customer_send) delete params.content
      if(!referrer_send) delete params.referrer_content

      this.sendFormData = params
      this.network().orderEnterPcyNo('send')
    //     }
    //     else {
    //       console.log(rules)
    //     }
    //   })
    },
    onSkip() {
      this.network().orderEnterPcyNo()
    },
    network() {
      return {
        orderEnterPcyNo: async (type) => {
          // let extra_params = {}
          // let extra_arr = JSON.parse(JSON.stringify(this.extraBenefit))
          // extra_arr.filter(item=>{
          //   delete item.key
          //   delete item.name
          //   extra_params = {...extra_params,...item}
          // })
          // console.log(extra_params)

          let params = {
            order_id: this.orderId,
            ...this.formData,
            // ...extra_params
          }
          const { data } = await orderEnterPcyNo(params)

          if(type == 'send') {
            this.network().sendOrderEnterPcyNoNotice()
          }
          else {
            this.dialog = false
            this.$emit('success')
          }
        },
        sendOrderEnterPcyNoNotice: async () => {
          const { data } = await sendOrderEnterPcyNoNotice({
            order_id: this.orderId,
            ...this.sendFormData
          })
          this.dialog = false
          this.$emit('success')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  .dialog-body{
    padding: 15px;
  }
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .item-content{
    padding-bottom: 30px;
    padding-top: 20px;
    border-bottom: 1px solid #D1D5DA;
  }
  .title-span{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
    margin-top: 30px;
  }
      h3 {
        padding-bottom: 5px;
      }
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
        display: flex;
        justify-content: space-between;
      }
      .form-item {
          & > span {
              //font-weight: bold;
              //font-size: 16px;
          }
      }
  .flex-align{
    align-items: center;
    .margin-time{
      margin: 0 10px;
    }
  }
    }
</style>
